import application from "./layout/application.vue";
import router from "./router";
if (import.meta.env.MODE === "simple-keiri") {
  import("./tailwind-simple-keiri.css");
} else {
  import("./tailwind.css");
}
import { createApp } from "vue";
import { createGtag } from "vue-gtag";
import "./global.ts";
import { initIosInputZoomFix } from "./ios-input-zoom-fix.ts";

initIosInputZoomFix();

const app = createApp(application);

app.use(router);
app.use(
  createGtag({
    tagId: FIREBASE_CONFIG.measurementId,
    pageTracker: {
      router,
      useScreenview: true,
    },
  })
);
app.config.globalProperties.BRANDING_CONFIG = BRANDING_CONFIG;

app.mount("#app");
